
export default {
  name: 'AppReviewTags',
  props: {
    review: { type: Object, required: true },
    forcedDevice: {
      type: String,
      default: null,
      validator: v => ['pc', 'mobile'].includes(v)
    }
  }
};
